export default __webpack_public_path__ + "static/designer-1-4fe4c2520e97698f114ebc71ac06de28.webp";